/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util (pure) — the privacy / terms links of the public
 *              booking consents: the TENANT's documents first (the struttura
 *              is the data controller), Beebeeboard only as data processor
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      -
 *   siblings:  components/booking-consent/notice.js (its main caller),
 *              booking-validation.js (validateGdprOptions, the error flags)
 *   tests:     consent-links-test.js
 *   gotchas:   the tenant fields are free text typed in the settings: a URL
 *              without a scheme ("www.x.it") is promoted to https, anything
 *              else that is not http(s) (javascript:, data:, a sentence) is
 *              refused and the caller falls back to the Beebeeboard pages.
 *
 * Where the tenant documents live (session.option_field, the organization's
 * option JSON loaded with /organizations/open):
 *   - privacy policy: `ecommerce_general_term` (Settings > GDPR «Privacy
 *     policy URL», shared with e-commerce checkout)
 *   - general terms:  `booking_settings.checkin_general_term` (Settings >
 *     Booking, the check-in terms link the check-in tick accepts)
 */

export const BEEBEEBOARD_PRIVACY_URL = 'https://beebeeboard.com/normativa-privacy';
export const BEEBEEBOARD_TERMS_URL = 'https://beebeeboard.com/termini-e-condizioni';

const HTTP_URL = /^https?:\/\/[^\s]+$/i;
const BARE_HOST = /^[a-z0-9-]+(\.[a-z0-9-]+)+(:\d+)?(\/[^\s]*)?$/i;

// A tenant-typed link made safe to put in an href, or null when it is not a web address.
export function safeExternalUrl(value) {
  const url = typeof value === 'string' ? value.trim() : '';
  if (!url) return null;
  if (HTTP_URL.test(url)) return url;
  if (BARE_HOST.test(url)) return `https://${url}`;
  return null;
}

// The tenant's privacy policy URL, or null when the tenant has not configured one.
export function tenantPrivacyUrl(optionField) {
  return safeExternalUrl(optionField?.ecommerce_general_term);
}

// The tenant's general terms URL, or null when the tenant has not configured one.
export function tenantTermsUrl(optionField) {
  return safeExternalUrl(optionField?.booking_settings?.checkin_general_term);
}
